import axios from 'axios'
import qs from 'qs'

const state = () => ({
  loaded: false,
  dealers: [],
  currentPage: 1,
  itemsPerPage: 3, // 3
  numberOfPages: 1,
  numberOfTotalDealers: 0
})

const getters = {
  getParams: (state, getters, rootState) => {
    const params = {
      currentPage: state.currentPage,
      itemsPerPage: state.itemsPerPage
    }
    if (rootState.latitude && rootState.longitude) {
      params.lat = {
        equals: rootState.latitude
      }
      params.lng = {
        equals: rootState.longitude
      }
    }
    return params
  }
}

const mutations = {
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setDealers (state, payload) {
    state.dealers = payload
  },
  addDealers (state, payload) {
    state.dealers = [...state.dealers, ...payload]
  },
  resetCurrentPage (state) {
    state.currentPage = 1
    state.dealers = []
  },
  increaseCurrentPage (state) {
    state.currentPage += 1
  },
  setNumberOfPages (state, payload) {
    state.numberOfPages = payload
  },
  setNumberOfTotalDealers (state, payload) {
    state.numberOfTotalDealers = payload
  }
}

const actions = {
  async get ({ commit, getters }) {
    commit('setLoaded', false)
    try {
      const response = await axios.get(window.app.dealersearch.api_base + 'dealers' + '/?' + qs.stringify(getters.getParams))
      state.currentPage === 1
        ? commit('setDealers', response.data.dealers)
        : commit('addDealers', response.data.dealers)
      commit('setNumberOfPages', response.data.numberOfPages)
      commit('setNumberOfTotalDealers', response.data.numberOfTotalItems)
      commit('setLoaded', true)
      return response
    } catch (e) {
      commit('setErrors', e, { root: true })
    }
  },
  async increasePage ({ commit }) {
    commit('increaseCurrentPage')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
